import { HttpError, UserCustomizationsModel } from '@rd/types';
import {
  UserCustomizationsActions,
  UserCustomizationsActionTypes,
} from '../actions/user-customizations.actions';

export interface UserCustomizationsState {
  userCustomizations: UserCustomizationsModel;
  loading: boolean;
  error: HttpError | null;
}

const initialState: UserCustomizationsState = {
  userCustomizations: {
    supplementCardPopupDisplayed: undefined,
    bankWideLoyaltyPopupDisplayed: undefined,
  },
  loading: false,
  error: null,
};

export function userCustomizationsReducer(
  state: UserCustomizationsState = initialState,
  action: UserCustomizationsActions,
): UserCustomizationsState {
  switch (action.type) {
    case UserCustomizationsActionTypes.PUT_USER_CUSTOMIZATIONS:
      return {
        userCustomizations: {
          ...state.userCustomizations,
          ...action.payload,
        },
        loading: true,
        error: null,
      };
    case UserCustomizationsActionTypes.PUT_USER_CUSTOMIZATIONS_SUCCESS:
      return {
        userCustomizations: {
          ...state.userCustomizations,
        },
        loading: false,
        error: null,
      };
    case UserCustomizationsActionTypes.GET_USER_CUSTOMIZATIONS:
      return {
        userCustomizations: {
          ...state.userCustomizations,
        },
        loading: true,
        error: null,
      };
    case UserCustomizationsActionTypes.GET_USER_CUSTOMIZATIONS_SUCCESS:
      return {
        userCustomizations: {
          ...state.userCustomizations,
          ...action.payload,
        },
        loading: false,
        error: null,
      };
    case UserCustomizationsActionTypes.PUT_USER_CUSTOMIZATIONS_FAILED:
    case UserCustomizationsActionTypes.GET_USER_CUSTOMIZATIONS_FAILED:
      return {
        userCustomizations: {
          ...state.userCustomizations,
        },
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
